import React from 'react';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons';

import PageHeader from 'components/ui/page_header';

import MergeButton from './merge_button';

export function DuplicatesPageHeader() {
  return (
    <PageHeader>
      <PageHeader.Heading
        description="Manage your properties database"
        icon={faBuilding}
        title="Properties"
      />
      <PageHeader.Actions>
        <div className="d-none d-md-flex">
          <MergeButton />
        </div>
      </PageHeader.Actions>
    </PageHeader>
  );
}

export default DuplicatesPageHeader;
